// extracted by mini-css-extract-plugin
export default {"TextInfo":"TextInfo__TextInfo___IHj70","button":"TextInfo__button___NHVJ_","icon":"TextInfo__icon___ZL6uH","noWrap":"TextInfo__noWrap___sNG7o"};